import React, { createContext, useContext, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getItem } from '../../utils/localStorage'
import { userLoaderAction } from '../../redux/authReducer'

const AuthContext = createContext()
export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch()
    const isLogin = useSelector((state) => state.auth.isLogin)

    // Hydrate Redux state từ localStorage khi app start
    useEffect(() => {
        if (!isLogin) {
            const access_token = getItem('access_token')
            const userData = getItem('userData')
            const roles = getItem('roles')
            
            if (access_token && userData) {
                try {
                    const parsedToken = JSON.parse(access_token)
                    const parsedUser = JSON.parse(userData)
                    const parsedRoles = roles ? JSON.parse(roles) : []
                    
                    dispatch(userLoaderAction({
                        access_token: parsedToken,
                        user: { ...parsedUser, roles: parsedRoles }
                    }))
                } catch (error) {
                    console.error('Lỗi hydrate auth state:', error)
                }
            }
        }
    }, [])

    const hasToken = !!getItem('access_token')
    const isAuthenticated = (isLogin || hasToken)

    return (
        <AuthContext.Provider value={{ isAuthenticated }}>
            {children}
        </AuthContext.Provider>
    )
}
